import { DataType } from '../../components/data-type-widgets/data-type/data-type-component';
import {
  EntityGroupConfigDTO,
  FieldConfigDTO,
  FormColumnConfigDTO,
  FormRowConfigDTO,
  MenuDTO,
  MenuGroupDTO,
  SystemDTO,
} from '../../system/system-dtos';

const PROMO_CLAIM_RATE_FIELD: FieldConfigDTO = {
  name: 'promoClaimRate',
  label: 'Promo Claim Rate',
  noLabel: true,
  type: DataType.promo_claim_rate,
};

const hasFieldOfType = (fields: FieldConfigDTO[], type: DataType): boolean =>
  fields.some((field) => field.type === type);

export function addPromoClaimRateToMarketingConfig(system: SystemDTO): SystemDTO {
  let marketingCardFound = false;

  const updateColumn = (column: FormColumnConfigDTO): FormColumnConfigDTO => {
    if (!column.fields || !hasFieldOfType(column.fields, DataType.promotion_exclude)) {
      return column;
    }
    marketingCardFound = true;
    if (hasFieldOfType(column.fields, DataType.promo_claim_rate)) {
      return column;
    }
    return { ...column, fields: [PROMO_CLAIM_RATE_FIELD, ...column.fields] };
  };

  const updateRow = (row: FormRowConfigDTO): FormRowConfigDTO => {
    const columns = mapIfChanged(row.columns, updateColumn);
    return columns === row.columns ? row : { ...row, columns };
  };

  const updateEntityGroup = (entityGroup: EntityGroupConfigDTO): EntityGroupConfigDTO => {
    const menuItems = mapIfChanged(entityGroup.menuItems, updateMenuItem);
    return menuItems === entityGroup.menuItems ? entityGroup : { ...entityGroup, menuItems };
  };

  const updateMenuItem = (menuItem: MenuDTO): MenuDTO => {
    const entityGroup = menuItem.entityGroup && updateEntityGroup(menuItem.entityGroup);
    const rows = menuItem.singleForm && mapIfChanged(menuItem.singleForm.rows, updateRow);
    if (entityGroup === menuItem.entityGroup && rows === menuItem.singleForm?.rows) {
      return menuItem;
    }
    return {
      ...menuItem,
      ...(entityGroup && { entityGroup }),
      ...(rows && { singleForm: { ...menuItem.singleForm, rows } }),
    };
  };

  const updateMenuGroup = (menuGroup: MenuGroupDTO): MenuGroupDTO => {
    const menuItems = mapIfChanged(menuGroup.menuItems, updateMenuItem);
    return menuItems === menuGroup.menuItems ? menuGroup : { ...menuGroup, menuItems };
  };

  const menuGroups = mapIfChanged(system.menuGroups, updateMenuGroup);

  if (!marketingCardFound) {
    console.warn('Promo claim rate: no `promotion_exclude` field found in the system config, panel not added');
  }
  return menuGroups === system.menuGroups ? system : { ...system, menuGroups };
}

function mapIfChanged<T>(items: T[] | undefined, update: (item: T) => T): T[] | undefined {
  const updated = items?.map(update);
  return updated?.every((item, index) => item === items[index]) ? items : updated;
}
